import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { ReactComponent as DLeftArrow } from '../../../../../../img/d-left-arrow-calendar.svg';
import { ReactComponent as DRightArrow } from '../../../../../../img/d-right-arrow-calendar.svg';
import { ReactComponent as LeftArrow } from '../../../../../../img/left-arrow-calendar.svg';
import { ReactComponent as RightArrow } from '../../../../../../img/right-arrow-calendar.svg';

import './style.scss';

/**
 * @callback onChangeCb
 * @param {Moment} day
 */

/**
 * Calendar header
 * @param {Moment} day
 * @param {onChangeCb} onChange
 * @returns {JSX.Element}
 * @constructor
 */
function CalendarHeader({ day = moment(), onChange }) {
  const [week, setWeek] = useState(day.clone());
  const [startDate, setStartDate] = useState(new Date(day.clone().format('YYYY-MM-DD')));

  const currMonthName = useCallback(() => week.clone().format('MMMM'), [week]);
  const currYear = useCallback(() => week.clone().format('YYYY'), [week]);
  const currDay = useCallback(() => week.clone().format('D'), [week]);

  const prevWeek = useCallback(() => week.clone().subtract(2, 'week'), [week]);
  const nextWeek = useCallback(() => week.clone().add(2, 'week'), [week]);

  const handleClickLeft = useCallback(() => {
    const pWeek = prevWeek();
    setWeek(pWeek);
    if (onChange) {
      onChange(pWeek);
    }
  }, [onChange, prevWeek]);
  const handleClickRight = useCallback(() => {
    const nWeek = nextWeek();
    setWeek(nWeek);
    if (onChange) {
      onChange(nWeek);
    }
  }, [nextWeek, onChange]);

  const changeDate = useCallback(
    (date) => {
      onChange(moment(date));
    },
    [onChange]
  );

  const prevDay = useCallback(() => {
    const substractDay = day.clone().subtract(1, 'day');
    onChange(substractDay);
  }, [day, onChange]);

  const nextDay = useCallback(() => {
    const addDay = day.clone().add(1, 'day');
    onChange(addDay);
  }, [day, onChange]);

  const formatD = 'mm-dd-yyyy';
  const popperPlacement = 'bottom-start';
  const withPortal = false;

  useEffect(() => {
    setWeek(day.clone());
    setStartDate(new Date(day.clone().format('YYYY-MM-DD')));
  }, [day]);

  return (
    <div className="header">
      <DLeftArrow className="header_arrow" onClick={handleClickLeft} />
      <LeftArrow onClick={prevDay} />
      <DatePicker
        customInput={<div className="header_date">{`${currMonthName()} ${currDay()}, ${currYear()}`}</div>}
        selected={startDate}
        onChange={changeDate}
        popperPlacement={popperPlacement}
        timeIntervals={15}
        dateFormat={formatD}
        timeCaption="Time"
        withPortal={withPortal}
        dropdownMode="select"
      />
      <RightArrow onClick={nextDay} />
      <DRightArrow className="header_arrow" onClick={handleClickRight} />
    </div>
  );
}

CalendarHeader.propTypes = {
  day: PropTypes.any,
  onChange: PropTypes.func
};

export default React.memo(CalendarHeader);
